// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-o_fV","advertDetailHeaderPrice__value":"c-o_fW","advertDetailHeaderPrice__label":"c-o_fX"};